import React from 'react';
import LogoText from './LogoText';

interface Props {
  children: React.ReactNode;
}

const Loader: React.FC<Props> = ({ children }) => (
  <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-xl text-gray-400">
    <LogoText />
    {children}
  </div>
);

export default Loader;
